import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HelpAccessService } from './help-access.service';

export const helpGuard: CanActivateFn = async () => {
    const access = inject(HelpAccessService), router = inject(Router);
    return await access.ensure() || (access.failure() === 'unavailable' && access.login.isAutenticado()) || router.createUrlTree(['/auth/login']);
};
